import { createSlice } from '@reduxjs/toolkit';

export const bookingWidgetRoomFormSlice = createSlice({
    name: 'roomBookingForm',
    initialState: {
        room: {},
        selectedRoomFormIndex: null,
        selectedRateID: null,
        isDrawerOpen: false,
    },
    reducers: {
        setSelectedRoomForm: (state, action) => {
            state.selectedRoomFormIndex = action.payload.selectedRoomFormIndex;
        },
        setSelectedRateID: (state, action) => {
            state.selectedRateID = action.payload.selectedRateID;
        },
        setSelectedFormRoom: (state, action) => {
            let rates = [];
            if (action.payload?.room?.rates?.length > 0) {
                rates = action.payload?.room?.rates?.filter((obj) => {
                    return obj.rateID === state.selectedRateID;
                });
            }

            state.room = { ...action.payload.room, rates: rates };
        },
    },
});

export const { setSelectedRoomForm, setSelectedRateID, setSelectedFormRoom } =
    bookingWidgetRoomFormSlice.actions;
